import { getFullUrl } from 'hubspot-url-utils';
import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { getIsLocalDevelopment } from 'marketplace-ui-common/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function ThirdPartyAuthStep({
  isPreview,
  name,
  portalId,
  redirectUri,
  // only used in legacy flow to pass code to third party auth
  renderedHeaderIcons,
  popUpWindow,
  onPopUpClick,
  isSecureFlow = false,
  installUrl,
  slug
}) {
  const renderedPopUpCTA = useMemo(() => {
    const isLocalDevelopment = getIsLocalDevelopment();
    let popUpUrl;
    if (isSecureFlow) {
      // New secure flow: use installUrl with step=authorize parameter
      const returnUrl = `${getFullUrl(isLocalDevelopment ? 'local' : 'app')}/marketplace/${portalId}/listing/${slug}/third-party-auth-state`;

      // For preview, use a mock installUrl if not provided
      const baseUrl = isPreview ? installUrl || 'https://example-app.com/install' : installUrl;
      const url = new URL(baseUrl);
      url.searchParams.set('step', 'authorize');
      url.searchParams.set('returnUrl', returnUrl);
      popUpUrl = url.toString();
    } else {
      // Legacy flow: use redirectUri (from HubSpot OAuth) with step=legacy parameter
      // Guard against empty or invalid redirectUri
      if (!redirectUri) {
        popUpUrl = '';
      } else {
        const previewRedirectUri = isPreview ? `${redirectUri}?code=HUBSPOT_CODE_VALUE` : redirectUri;
        const returnUrl = `${getFullUrl(isLocalDevelopment ? 'local' : 'app')}/marketplace/${portalId}/listing/${slug}/install-success`;
        try {
          const url = new URL(previewRedirectUri);
          url.searchParams.set('step', 'legacy');
          url.searchParams.set('returnUrl', returnUrl);
          popUpUrl = url.toString();
        } catch (_unused) {
          // If URL construction fails, use empty string
          // this should never happen, but we'll handle it just in case
          popUpUrl = '';
        }
      }
    }
    if (popUpWindow) {
      return /*#__PURE__*/_jsxs(Tile, {
        compact: true,
        padding: "800",
        marginBlockStart: "600",
        children: [/*#__PURE__*/_jsx(TileSection, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.install.thirdPartyStep.loginPage",
            options: {
              name
            }
          })
        }), /*#__PURE__*/_jsx(TileSection, {
          children: /*#__PURE__*/_jsx(Button, {
            use: "link",
            onClick: () => onPopUpClick(popUpUrl),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "detailsPage.install.thirdPartyStep.openLink"
            })
          })
        })]
      });
    } else {
      return /*#__PURE__*/_jsx(Button, {
        use: "primary",
        marginBlockStart: "600",
        onClick: () => onPopUpClick(popUpUrl),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.install.thirdPartyStep.signIn"
        })
      });
    }
  }, [isPreview, redirectUri, portalId, popUpWindow, onPopUpClick, name, isSecureFlow, installUrl, slug]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderedHeaderIcons, /*#__PURE__*/_jsx(Text, {
      as: "h1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.install.thirdPartyStep.header",
        options: {
          name
        }
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginBlockStart: "300",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.install.thirdPartyStep.subheader",
        options: {
          name
        }
      }), renderedPopUpCTA]
    })]
  });
}